<input type="file" class="file-input" style="display: none"
       [accept]="requiredFileTypes"
       [multiple]="multiple"
       (change)="onFileSelected($event)" #fileUpload>

<div class="file-upload">

    <div *ngFor="let file of files">
        <div class="chip">
            <span class="chip-label">{{ file.name }} ({{ file.type }} {{ file.size }})</span>
            <span class="fa fa-times-circle" (click)="remove(file)"></span>
        </div>
    </div>
    <div *ngIf="!_valid">
        {{ 'uploader.invalid_file_list' | translate }} {{ invalidFilesDescription }}
    </div>

    <button class="btn btn-primary"
            (click)="fileUpload.click()">
        <em class="fas fa-paperclip"></em>
        <span> {{ 'common.attachments' | translate }}</span>
    </button>

</div>

<!--
<div class="progress">

    <mat-progress-bar class="progress-bar" mode="determinate"
                      [value]="uploadProgress" *ngIf="uploadProgress">

    </mat-progress-bar>

    <mat-icon class="cancel-upload" (click)="cancelUpload()"
              *ngIf="uploadProgress">delete_forever</mat-icon>

</div>
-->

